
import React, { useState, lazy, Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import LiteYouTubeEmbed from 'react-lite-youtube-embed';
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';
import Home from "./components/pages/home.js";
import Navbar from './components/layout/Header.js';
import WhySFL from "./components/pages/why-us.js";
import WhyChooseSFL from "./components/pages/why-choose-sfl.js";
import SFLINFO from "./components/pages/hearing-aids-info.js";
import SFLOverview from "./components/pages/hearing-aids-overview.js";
import PriceDelhi from "./components/pages/hearing-aids-price-delhi.js";
import SigniaHearingAids from "./components/pages/signia-hearing-aids.js";
import PhonakHearingAids from "./components/pages/phonak-hearing-aids.js";
import ResoundHearingAids from "./components/pages/resound-hearing-aids.js";
import SigniaHearingAidsIndia from "./components/pages/signia-hearing-aids-india.js";
import PhonakHearingAidsIndia from "./components/pages/phonak-hearing-aids-india.js";
import ResoundHearingAidsIndia from "./components/pages/resound-hearing-aids-india.js";
import PriceAgra from "./components/pages/hearing-aids-price-agra.js";
import PriceAmbala from "./components/pages/hearing-aids-price-ambala.js";
import PriceAmritsar from "./components/pages/hearing-aids-price-amritsar.js";
import PriceBathinda from "./components/pages/hearing-aids-price-bathinda.js";
import PriceChandigarh from "./components/pages/hearing-aids-price-chandigarh.js";
import PriceDehradun from "./components/pages/hearing-aids-price-dehradun.js";
import PriceDelhiNCR from "./components/pages/hearing-aids-price-delhi-ncr.js";
import PriceFaridabad from "./components/pages/hearing-aids-price-faridabad.js";
import PriceGandhiNagar from "./components/pages/hearing-aids-price-gandhi-nagar.js";
import PriceGhaziabad from "./components/pages/hearing-aids-price-ghaziabad.js";
import PriceGurugram from "./components/pages/hearing-aids-price-gurugram.js";
import PriceHoshiarpur from "./components/pages/hearing-aids-price-hoshiarpur.js";
import PriceJalandhar from "./components/pages/hearing-aids-price-jalandhar.js";
import PriceJammu from "./components/pages/hearing-aids-price-jammu.js";
import PriceKarnal from "./components/pages/hearing-aids-price-karnal.js";
import PriceKolkata from "./components/pages/hearing-aids-price-kolkata.js";
import PriceLucknow from "./components/pages/hearing-aids-price-lucknow.js";
import PriceLudhiana from "./components/pages/hearing-aids-price-ludhiana.js";
import PriceMoradabad from "./components/pages/hearing-aids-price-moradabad.js";
import PricePrayagraj from "./components/pages/hearing-aids-price-prayagraj.js";
import PriceGurgaon from "./components/pages/hearing-aids-price-gurgaon.js";
import Price from "./components/pages/hearing-aids-price.js";
import Cost from "./components/pages/hearing-aids-cost.js";

import CentreDelhiNCR from "./components/pages/hearing-aids-centre-delhi-ncr.js";
import CentreDelhi from "./components/pages/hearing-aids-centre-delhi.js";
import CentreJalandhar from "./components/pages/hearing-aids-centre-jalandhar.js";
import CentreKanpur from "./components/pages/hearing-aids-centre-kanpur.js";
import CentreKarnal from "./components/pages/hearing-aids-centre-karnal.js";
import CentreKolkata from "./components/pages/hearing-aids-centre-kolkata.js";
import CentreLucknow from "./components/pages/hearing-aids-centre-lucknow.js";
import CentreMumbai from "./components/pages/hearing-aids-centre-mumbai.js";
import CentrePrayagraj from "./components/pages/hearing-aids-centre-prayagraj.js";
import CentreAhmedabad from "./components/pages/hearing-aids-centre-ahmedabad.js";
import CentreGurugram from "./components/pages/hearing-aids-centre-gurugram.js";
import CentreGhaziabad from "./components/pages/hearing-aids-centre-ghaziabad.js";
import CentreFaridabad from "./components/pages/hearing-aids-centre-faridabad.js";
import CentreHoshiarpur from "./components/pages/hearing-aids-centre-hoshiarpur.js";
import CentreJammu from "./components/pages/hearing-aids-centre-jammu.js";
import CentreLudhiana from "./components/pages/hearing-aids-centre-ludhiana.js";
import CentreMoradabad from "./components/pages/hearing-aids-centre-moradabad.js";
import CentreAmritsar from "./components/pages/hearing-aids-centre-amritsar.js";
import CentreBathinda from "./components/pages/hearing-aids-centre-bathinda.js";
import CentreChandigarh from "./components/pages/hearing-aids-centre-chandigarh.js";
import CentreDehradun from "./components/pages/hearing-aids-centre-dehradun.js";
import CentreAgra from "./components/pages/hearing-aids-centre-agra.js";
import CentreAmbala from "./components/pages/hearing-aids-centre-ambala.js";
import CentreAnand from "./components/pages/hearing-aids-centre-anand.js";
import CentreKerala from "./components/pages/hearing-aids-centre-kerala.js"; 
import CentreBengaluru from "./components/pages/hearing-aids-centre-bengaluru.js";
import CentreGandhNagar from "./components/pages/hearing-aids-centre-gandhi-nagar.js";  
import CentreGuwahati from "./components/pages/hearing-aids-centre-guwahati.js"; 
import CentreNoida from "./components/pages/hearing-aids-centre-noida.js"; 
import CentrePatna from "./components/pages/hearing-aids-centre-patna.js";
import CentreSurat from "./components/pages/hearing-aids-centre-surat.js"; 
import CentreVadodara from "./components/pages/hearing-aids-centre-vadodara.js";
import CentreGurgaon from "./components/pages/hearing-aids-centre-gurgaon.js";
import CentrePunjab from "./components/pages/hearing-aids-centre-punjab.js";


import InfoAgra from "./components/pages/hearing-aids-info-agra.js";
import InfoChandigarh from "./components/pages/hearing-aids-info-chandigarh.js";
import InfoJalandhar from "./components/pages/hearing-aids-info-jalandhar.js";
import InfoKarnal from "./components/pages/hearing-aids-info-karnal.js";
import InfoAmritsar from "./components/pages/hearing-aids-info-amritsar.js";
import InfoJammu from "./components/pages/hearing-aids-info-jammu.js";
import InfoBathinda from "./components/pages/hearing-aids-info-bathinda.js";
import InfoLudhiana from "./components/pages/hearing-aids-info-ludhiana.js";
import InfoFaridabad from "./components/pages/hearing-aids-info-faridabad.js";
import InfoGhaziabad from "./components/pages/hearing-aids-info-ghaziabad.js";
import InfoGurugram from "./components/pages/hearing-aids-info-gurugram.js";
import InfoDehradun from "./components/pages/hearing-aids-info-dehradun.js";
import InfoPrayagraj from "./components/pages/hearing-aids-info-prayagraj.js";
import InfoKolkata from "./components/pages/hearing-aids-info-kolkata.js";
import InfoAmbala from "./components/pages/hearing-aids-info-ambala.js";
import InfoDelhi from "./components/pages/hearing-aids-info-delhi.js";
import InfoDelhiNCR from "./components/pages/hearing-aids-info-delhi-ncr.js";
import InfoHosiarpur from "./components/pages/hearing-aids-info-hoshiarpur.js";
import InfoLucknow from "./components/pages/hearing-aids-info-lucknow.js";
import InfoMoradabad from "./components/pages/hearing-aids-info-moradabad.js";
import InfoGurgaon from "./components/pages/hearing-aids-info-gurgaon.js";
import ThankYouPage from "./components/pages/thankyou";
import ThankPage from "./components/pages/thank-you-gurgaon";
import ThankPageKolkata from "./components/pages/thank-you-kolkata";  
import NotFound from "./components/pages/notfound";
function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
         <Route path="hearing-aids-info" element={<SFLINFO />} />
         <Route path="hearing-aids-overview" element={<SFLOverview />} />
         <Route path="why-us" element={<WhySFL />} />
          <Route path="why-choose-sfl" element={<WhyChooseSFL />} />

          <Route path="hearing-aids-centre-delhi-ncr" element={<CentreDelhiNCR />} />
          <Route path="hearing-aids-centre-delhi" element={<CentreDelhi />} />
          <Route path="hearing-aids-centre-jalandhar" element={<CentreJalandhar />} />  
          <Route path="hearing-aids-centre-kanpur" element={<CentreKanpur />} />
          <Route path="hearing-aids-centre-karnal" element={<CentreKarnal />} />
          <Route path="hearing-aids-centre-kolkata" element={<CentreKolkata />} />
          <Route path="hearing-aids-centre-lucknow" element={<CentreLucknow />} />
          <Route path="hearing-aids-centre-mumbai" element={<CentreMumbai />} />
          <Route path="hearing-aids-centre-prayagraj" element={<CentrePrayagraj />} />
          <Route path="hearing-aids-centre-ahmedabad" element={<CentreAhmedabad />} />
          <Route path="hearing-aids-centre-gurugram" element={<CentreGurugram />} />
          <Route path="hearing-aids-centre-ghaziabad" element={<CentreGhaziabad />} />
          <Route path="hearing-aids-centre-faridabad" element={<CentreFaridabad />} />
          <Route path="hearing-aids-centre-hoshiarpur" element={<CentreHoshiarpur />} />
          <Route path="hearing-aids-centre-jammu" element={<CentreJammu />} />
          <Route path="hearing-aids-centre-ludhiana" element={<CentreLudhiana />} />
          <Route path="hearing-aids-centre-moradabad" element={<CentreMoradabad />} />
          <Route path="hearing-aids-centre-amritsar" element={<CentreAmritsar />} />
          <Route path="hearing-aids-centre-bathinda" element={<CentreBathinda />} />
          <Route path="hearing-aids-centre-chandigarh" element={<CentreChandigarh />} />
          <Route path="hearing-aids-centre-dehradun" element={<CentreDehradun />} />
          <Route path="hearing-aids-centre-agra" element={<CentreAgra />} />
          <Route path="hearing-aids-centre-ambala" element={<CentreAmbala />} />
          <Route path="hearing-aids-centre-anand" element={<CentreAnand/>} />
          <Route path="hearing-aids-centre-kerala" element={<CentreKerala/>} /> 
          <Route path="hearing-aids-centre-bengaluru" element={<CentreBengaluru/>} />
          <Route path="hearing-aids-centre-gandhi-nagar" element={<CentreGandhNagar/>} />
          <Route path="hearing-aids-centre-guwahati" element={<CentreGuwahati/>} />
          <Route path="hearing-aids-centre-noida" element={<CentreNoida/>} />
          <Route path="hearing-aids-centre-patna" element={<CentrePatna />} />
          <Route path="hearing-aids-centre-surat" element={<CentreSurat/>} />
          <Route path="hearing-aids-centre-vadodara" element={<CentreVadodara/>} />
          <Route path="hearing-aids-centre-gurgaon" element={<CentreGurgaon/>} />
          <Route path="hearing-aids-centre-punjab" element={<CentrePunjab />} />
          
                
    
        <Route path="hearing-aids-price-delhi" element={<PriceDelhi />} />
        <Route path="hearing-aids-price-agra" element={<PriceAgra />} />
        <Route path="hearing-aids-price-ambala" element={<PriceAmbala />} />
        <Route path="hearing-aids-price-amritsar" element={<PriceAmritsar />} />
        <Route path="hearing-aids-price-bathinda" element={<PriceBathinda />} />
        <Route path="hearing-aids-price-chandigarh" element={<PriceChandigarh />} />
        <Route path="hearing-aids-price-dehradun" element={<PriceDehradun />} />
        <Route path="hearing-aids-price-delhi-ncr" element={<PriceDelhiNCR />} />
        <Route path="hearing-aids-price-faridabad" element={<PriceFaridabad />} />
        <Route path="hearing-aids-price-gandhi-nagar" element={<PriceGandhiNagar />} />
        <Route path="hearing-aids-price-ghaziabad" element={<PriceGhaziabad />} />
        <Route path="hearing-aids-price-gurugram" element={<  PriceGurugram />} />
        <Route path="hearing-aids-price-hoshiarpur" element={<PriceHoshiarpur />} />
        <Route path="hearing-aids-price-jalandhar" element={<PriceJalandhar />} />
        <Route path="hearing-aids-price-jammu" element={<PriceJammu />} />
        <Route path="hearing-aids-price-karnal" element={<PriceKarnal />} />
        <Route path="hearing-aids-price-kolkata" element={<PriceKolkata />} />
        <Route path="hearing-aids-price-lucknow" element={<PriceLucknow />} />
        <Route path="hearing-aids-price-ludhiana" element={<PriceLudhiana />} />
        <Route path="hearing-aids-price-moradabad" element={<PriceMoradabad />} />
        <Route path="hearing-aids-price-prayagraj" element={<PricePrayagraj />} />
        <Route path="hearing-aids-price-gurgaon" element={<PriceGurgaon />} />
        <Route path="hearing-aids-price" element={<Price />} />
        <Route path="hearing-aids-cost" element={<Cost />} />


        <Route path="hearing-aids-info-agra" element={<InfoAgra />} />
        <Route path="hearing-aids-info-chandigarh" element={<InfoChandigarh />} />
        <Route path="hearing-aids-info-jalandhar" element={<InfoJalandhar />} />
        <Route path="hearing-aids-info-karnal" element={<InfoKarnal />} />
        <Route path="hearing-aids-info-amritsar" element={<InfoAmritsar />} />
        <Route path="hearing-aids-info-jammu" element={<InfoJammu />} />
        <Route path="hearing-aids-info-bathinda" element={<InfoBathinda />} />
        <Route path="hearing-aids-info-ludhiana" element={<InfoLudhiana />} />
        <Route path="hearing-aids-info-faridabad" element={<InfoFaridabad />} />
        <Route path="hearing-aids-info-ghaziabad" element={<InfoGhaziabad />} />
        <Route path="hearing-aids-info-gurugram" element={<InfoGurugram />} />
        <Route path="hearing-aids-info-dehradun" element={<InfoDehradun />} />
        <Route path="hearing-aids-info-prayagraj" element={<InfoPrayagraj />} />
        <Route path="hearing-aids-info-hoshiarpur" element={<InfoHosiarpur />} />
        <Route path="hearing-aids-info-kolkata" element={<InfoKolkata />} />
        <Route path="hearing-aids-info-ambala" element={<InfoAmbala />} />
        <Route path="hearing-aids-info-delhi" element={<InfoDelhi />} />
        <Route path="hearing-aids-info-delhi-ncr" element={<InfoDelhiNCR />} />
        <Route path="hearing-aids-info-dehradun" element={<InfoDehradun />} /> 
        <Route path="hearing-aids-info-lucknow" element={<InfoLucknow />} /> 
        <Route path="hearing-aids-info-moradabad" element={<InfoMoradabad />} /> 
        <Route path="hearing-aids-info-gurgaon" element={<InfoGurgaon />} /> 
        
         <Route path="phonak-hearing-aids" element={<PhonakHearingAids />} />
         <Route path="resound-hearing-aids" element={<ResoundHearingAids />} />
         <Route path="signia-hearing-aids" element={<SigniaHearingAids />} />
         <Route path="signia-hearing-aids-india" element={<SigniaHearingAidsIndia />} />
         <Route path="phonak-hearing-aids-india" element={<PhonakHearingAidsIndia />} />
         <Route path="resound-hearing-aids-india" element={<ResoundHearingAidsIndia />} />

    <Route path="thankyou" element={<ThankYouPage />} />

    <Route path="thank-you-gurgaon" element={<ThankPage />} />
    <Route path="thank-you-kolkata" element={<ThankPageKolkata />} />
    <Route path="*" element={<NotFound />} />

       
      </Routes>
    </Router>
  );
}

export default App;